import { AG_GRID_LOCALE_DE } from '@ag-grid-community/locale';

const swissGermanLocale = Object.fromEntries(
  Object.entries(AG_GRID_LOCALE_DE).map(([key, value]) => [
    key,
    value.replace(/ß/g, 'ss'),
  ]),
) as Record<string, string>;

export const AG_GRID_LOCALE_DE_CH: Record<string, string> = {
  ...swissGermanLocale,
  loadingOoo: 'Wird geladen…',
  columns: 'Spalten',
  columnChooser: 'Spalten wählen',
  chooseColumns: 'Spalten wählen',
  searchOoo: 'Suchen…',
  selectAll: 'Alle auswählen',
  blanks: '(Leer)',
  noMatches: 'Keine Treffer',
};
